// صفحة مهام يوسف - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const YusufTasks = () => (
  <EmployeeTasksPage employeeName="يوسف" title="المصمم" backPath="/yusuf-dashboard" />
);

export default YusufTasks;
